import React from 'react'
import {
  path,
  map,
  join,
  split,
  ifElse,
  not,
  isNil,
  identity,
  length,
  pathOr,
  update,
} from 'ramda'
import * as Icons from '@/components/Icons'
import { UserPermission } from '@/graphql/auth'
import useAuth from '@/hooks/useAuth'
const { compose } = require('ramda')

export type RouteItem = {
  id: number
  title: string
  path: string
  component: typeof React.Component
  icon?: React.FunctionComponent
  disabled?: boolean
  param?: string
  children?: RouteItem[]
  hide?: RouteItem[]
  creatable?: boolean
  updatable?: boolean
  deletable?: boolean
  readable?: boolean
  isSubMenu: boolean
  code: string
  mainKey: string
  subKey: string
}

export type Route = RouteItem & {
  children: Array<RouteItem>
  hide: Array<RouteItem>
  disabled: boolean
}

export function useRoutes(routes: { [key: string]: any }) {
  const { user } = useAuth()

  if (!user) {
    return []
  }
  let _funcList = [...user.funcList]
  const idx = _funcList.findIndex(x => x.name === '設備管理')

  if (idx) {
    _funcList = update(idx, {
      ..._funcList[idx],
      children: [
        ...pathOr([], [idx, 'children'], _funcList),
        {
          code: 'watermonitor_management',
          creatable: true,
          deletable: true,
          icon: 'IconDevice',
          id: 438888,
          isSubMenu: true,
          mainKey: 'device mgmt',
          name: '水情偵測管理',
          parentId: 437,
          parentName: '設備管理',
          readable: true,
          subKey: 'watermonitor mgmt',
          updatable: true,
          url: '/device/water-monitor-management',
        },
      ] as any,
    })(_funcList)
  }

  return compose(
    map((x: UserPermission) => ({
      ...x,
      title: x.name,
      path: x.url,
      icon: ifElse(
        compose(not, isNil, path([x.icon])),
        () => (Icons as any)[x.icon],
        identity
      )(Icons),
      ...(x.isSubMenu
        ? {}
        : {
            component: path([
              compose(
                join(''),
                map((s: string) => s.charAt(0).toUpperCase() + s.slice(1)),
                split('/'),
                pathOr('', ['url'])
              )(x),
            ])(routes),
          }),
      children: compose(
        map((c: UserPermission) => ({
          ...c,
          title: c.name,
          path: c.url,
          component: path([
            compose(
              join(''),
              map((s: string) => s.charAt(0).toUpperCase() + s.slice(1)),
              split('-'),
              ifElse(v => length(v) === 3, pathOr('', [2]), pathOr('', [1])),
              // pathOr('', [2]),
              split('/'),
              pathOr('', ['url'])
            )(c),
          ])(routes),
        })),
        pathOr([], ['children'])
      )(x),
    })),
    pathOr([], ['funcList'])
  )(user)
}

export default useRoutes
